import Tel from 'modules/Tel.js'

$(document).ready(function() {
  Tel.callOnClick()
})
